import { render } from "./Cursors.vue?vue&type=template&id=989e07c0&scoped=true"
import script from "./Cursors.vue?vue&type=script&setup=true&lang=js"
export * from "./Cursors.vue?vue&type=script&setup=true&lang=js"

import "./Cursors.vue?vue&type=style&index=0&id=989e07c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-989e07c0"],['__file',"src/scripts/common/sideBars/design/Cursors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "989e07c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('989e07c0', __exports__)) {
    api.reload('989e07c0', __exports__)
  }
  
  module.hot.accept("./Cursors.vue?vue&type=template&id=989e07c0&scoped=true", () => {
    api.rerender('989e07c0', render)
  })

}


export default __exports__